(function () {
  var triggers = document.querySelectorAll('[data-greeting-dialog]');

  if (!triggers.length || typeof HTMLDialogElement === 'undefined') return;

  var setPageScrolling = function (enabled) {
    if (!window.fullpage_api) return;

    window.fullpage_api.setAllowScrolling(enabled);
    window.fullpage_api.setKeyboardScrolling(enabled);
  };

  triggers.forEach(function (trigger) {
    var dialog = document.getElementById(trigger.dataset.greetingDialog);

    if (!dialog) return;

    var closeButton = dialog.querySelector('[data-greeting-close]');
    var scrollContainer = dialog.querySelector('.front-greetings__dialog-inner');

    // Keep modal scrolling outside fullPage.js and its scrollOverflow wrapper.
    document.body.appendChild(dialog);

    dialog.addEventListener(
      'wheel',
      function (event) {
        event.stopPropagation();

        if (!scrollContainer) return;

        scrollContainer.scrollTop += event.deltaY;
        event.preventDefault();
      },
      { passive: false }
    );

    dialog.addEventListener('touchmove', function (event) {
      event.stopPropagation();
    });

    dialog.addEventListener('keydown', function (event) {
      if (!scrollContainer) return;

      var scrollDistance = 0;

      if ('PageDown' === event.key) scrollDistance = scrollContainer.clientHeight * 0.8;
      if ('PageUp' === event.key) scrollDistance = scrollContainer.clientHeight * -0.8;
      if ('ArrowDown' === event.key) scrollDistance = 48;
      if ('ArrowUp' === event.key) scrollDistance = -48;

      if (!scrollDistance) return;

      event.preventDefault();
      event.stopPropagation();
      scrollContainer.scrollBy({ top: scrollDistance, behavior: 'smooth' });
    });

    trigger.addEventListener('click', function () {
      setPageScrolling(false);
      dialog.showModal();
    });

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        dialog.close();
      });
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('close', function () {
      setPageScrolling(true);
      trigger.focus();
    });
  });
})();
